const BlazeValidationError = require('./validation');
const { PERMISSIONS_ERROR_STATUS } = require('../constants');

class BlazePermissionError extends BlazeValidationError {
  constructor(message, { action, resource, ...errorProperties } = {}) {
    super(message, errorProperties);
    this.status = PERMISSIONS_ERROR_STATUS;
    this.action = action;
    this.resource = resource;
  }
}

module.exports = BlazePermissionError;
